import React, { useEffect } from "react"
import { Link, useParams } from "react-router-dom"
import { inject, observer } from 'mobx-react'

const Bar = ( props ) => {
	
	const {id} = useParams();
	
	useEffect( () => {
		
		const fetchData = async () => {
			await props.Data.getById( id )
		}
		
		fetchData();
		
	}, [id] );
	
	
	useEffect( () => {
		document.title = `${id} - Zamówienie`
	}, [props] );
	
	return (
		<>
			
			<div className="bar mb">
				<div className="bar__header">
					<Link to="/"><i className="las la-arrow-left bar__back"></i></Link> <h1
					className={`text-${props.Data.item.slug_status}`}>#{props.Data.item.id}</h1>
				</div>
				<div className="bar__date">{props.Data.item.created}</div>
				<div className="bar__content mb">
					<div>
						<h3>Zmówienie</h3>
						<div className={""}>
							
							{props.Data.item.items && props.Data.item.items.map( ( item, key ) =>
								<div class={"card__product card__grid flex-middle"}>
									<div className={"flex flex-column"} key={`item${key}`}>
										<div className="card__product-title">
											{key + 1}. {item.name}
										</div>
										<small><b>{ item.features_name }</b></small>
									</div>
									<span className={`text-right`}>{item.gross}zł <b class={"ml-1"}>x{item.quantity}</b> <b class={"ml-1"}>{item.total_gross}</b> zł</span>
								</div>
							)}
						</div>
					</div>
					<div>
						<h3>Dane adresowe</h3>
						<p>{props.Data.item.address && props.Data.item.address.name}</p>
						<p>{props.Data.item.address && props.Data.item.address.phone}</p>
						<p>{props.Data.item.address && props.Data.item.address.email}</p>
						<p>
							{props.Data.item.address && props.Data.item.address.address}
						</p>
						<p>{props.Data.item.address && props.Data.item.address.zip} {props.Data.item.address && props.Data.item.address.city}</p>
					
					</div>
				</div>
				<div className={"flex flex-middle flex-space flex-between mb"}>
					<div className="text-right">Produkty</div>
					<div className=""><b>{props.Data.item.order_subtotal} zł</b></div>
				</div>
				<div className={"flex flex-middle flex-space flex-between mb"}>
					<div className="">{props.Data.item.delivery_name}</div>
					<div className=""><b>{props.Data.item.delivery_total} zł</b></div>
				</div>
				<div className={"flex flex-middle flex-space flex-between mb"}>
					<div className="">{props.Data.item.payment_name}</div>
					<div className=""><b>{props.Data.item.payment_total} zł</b></div>
				</div>
				<div className={"flex flex-middle flex-space flex-between mb"}>
					<div className="">{props.Data.item.additional_name}</div>
					<div className=""><b>{props.Data.item.additional_total} zł</b></div>
				</div>
				<div className={"flex flex-middle flex-space flex-between mb"}>
					<div className="">Razem</div>
					<div className=""><b>{props.Data.item.order_total} zł</b></div>
				</div>
				
				{props.Data.item.attention &&
				<div>
					<h3>Dodatkowe informacje</h3>
					<div className="bar__note">{props.Data.item.attention}</div>
				</div>
				}
			</div>
			<Link to="/" className="bar__opacity"></Link>
		</>
	)
}

export default inject( 'Data' )( observer( Bar ) )
